import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePDFAuth } from "../contexts/PDFAuthContext";


const ResumePageRedirect = () => {
  const navigate = useNavigate();
  const { authenticate } = usePDFAuth();

  useEffect(() => {
    authenticate();
    
       navigate("/resume", { replace: true });
  }, [navigate, authenticate]);

  return null;
};

export default ResumePageRedirect;
